import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_SHARE_VISUALS = createFcmDetails('supporter_share_visuals', {
	owner: 'Signature Growth',
	context: 'Supporter share visuals',
	description: 'Feature flag that enables the share visuals for supporters on the petition gamma page',
	import: false,
});
